export default __webpack_public_path__ + "static/media/mobile.b5cf87e2.svg";